// Render-only mapping for the SERVER-derived onboardingStage/overlays. The backend
// is the single source of truth for stage; this module never recomputes it.

export const STAGE_ORDER = ['notProvisioned', 'generated', 'printed', 'shipped', 'activated'];

const STAGE_LABELS = {
  notProvisioned: 'Not provisioned',
  generated: 'Generated',
  printed: 'Printed',
  shipped: 'Shipped',
  activated: 'Activated',
};

export function stageLabel(stage) {
  return STAGE_LABELS[stage] || stage;
}

// Badge supports variants: active | inactive | deleted | warning | success.
export function stageBadgeVariant(stage) {
  switch (stage) {
    case 'activated': return 'success';
    case 'shipped':
    case 'printed': return 'active';
    case 'generated': return 'warning';
    default: return 'inactive'; // notProvisioned / unknown
  }
}

export function countByStage(licenses) {
  const counts = { notProvisioned: 0, generated: 0, printed: 0, shipped: 0, activated: 0, expired: 0, disabled: 0 };
  for (const lic of licenses) {
    if (counts[lic.onboardingStage] !== undefined) counts[lic.onboardingStage] += 1;
    const overlays = lic.overlays || [];
    if (overlays.includes('expired')) counts.expired += 1;
    if (overlays.includes('disabled')) counts.disabled += 1;
  }
  return counts;
}
